'use client'

import { AuthForm } from '@shared/ui/src/components/auth/AuthForm';

export function SignInPage() {
  return <AuthForm mode="signin" />;
} 